import React from 'react'
import PropTypes from 'prop-types'
import IconCheck from '../../../img/icon-check.svg'
import IconQuestion from '../../../img/icon-question.svg'
import { pluralize } from '../../utils'


const Navigation = ({ items, active, scrollTo }) => (
    <nav className="report-nav column is-narrow is-hidden-touch">
        <h2 className="title is-4">Parcels & Projects</h2>
        <div className="scrollable-area">
            {items.map(item => (
                <div
                    className={`nav-item ${item.id === active ? 'active' : ''}`}
                    onClick={() => scrollTo(item.id)}
                    onKeyDown={(e) =>  e.key === 'Enter' ? scrollTo(item.id) : null}
                    key={item.id}
                    role="button"
                    tabIndex="0"
                >
                    <div className="status">
                        <div>
                            <span className="svg-icon icon-24">
                                <IconCheck />
                            </span>{' '}
                            {item.potential_count}
                        </div>
                        <span className="svg-icon icon-24 maybe">
                            <IconQuestion />
                        </span>{' '}
                        {item.possible_count}
                        <div />
                    </div>
                    {item.type === 'parcel' && (
                        <>
                            <p>
                                APN &nbsp;&nbsp; <span className="has-text-weight-bold">{item.apn}</span>
                            </p>
                            <p>
                                {item.address.address}
                                <br />
                                {`${item.address.city}, ${item.address.state} ${item.address.zip}`}
                            </p>
                        </>
                    )}
                    {item.type === 'project' && (
                        <>
                            <p className="has-text-weight-bold">{item.label}</p>
                            <p>
                                {item.children.length} {pluralize(item.children.length, 'parcel', 's')}
                            </p>
                        </>
                    )}
                </div>
            ))}
        </div>
    </nav>
)

Navigation.propTypes = {
    items: PropTypes.array.isRequired
}

export default Navigation
